import { Component, ChangeDetectionStrategy, inject, computed } from '@angular/core';
import { Router } from '@angular/router';
import { KeyboardService } from '../../../core/services/keyboard';
import { HapticDirective } from '../../directives/haptic';

/**
 * Barre d'accessoire globale du clavier : s'affiche juste au-dessus du clavier
 * natif (via `.keyboard-lift`) quand celui-ci est ouvert, et offre un bouton
 * pour le fermer manuellement. Masquée sur le chat pour ne pas masquer le composer.
 */
@Component({
  selector: 'app-keyboard-toolbar',
  imports: [HapticDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (shouldShow()) {
    <div
      class="keyboard-lift fixed inset-x-0 z-50 pointer-events-none flex justify-end px-3 py-1.5"
    >
      <button
        type="button"
        [appHaptic]="'light'"
        (click)="dismiss()"
        aria-label="Fermer le clavier"
        class="pointer-events-auto inline-flex items-center gap-1.5 rounded-full bg-paper/90 backdrop-blur-md px-3.5 py-1 text-[13px] font-extrabold text-accent shadow-sm border border-line active:scale-[0.97] transition"
      >
        <span class="material-icons-round text-[18px]">keyboard_hide</span>
        OK
      </button>
    </div>
    }
  `,
})
export class KeyboardToolbar {
  readonly keyboard = inject(KeyboardService);
  private router = inject(Router);

  readonly shouldShow = computed(() => {
    if (!this.keyboard.isVisible()) return false;
    return !this.router.url.includes('/chat');
  });

  dismiss(): void {
    void this.keyboard.dismiss();
  }
}
